module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialogs/select-dialog/select-dialog.component.css
// module id = ./src/app/shared/dialogs/select-dialog/select-dialog.component.css
// module chunks = main